import React, { FC, useEffect, useState } from 'react'
import LoanOfficerPopUp from '@mortgage-pos/ui/components/pricing/LoanOfficerPopUp'
import { useStoreState } from '@mortgage-pos/ui/store'
import { buildSummaryInfo } from '@mortgage-pos/ui/utils/buildSummaryInfo'

export enum PhoneAppVerifyDetailsVariant {
  Primary,
  CoBorrower,
}

interface Props {
  variant: PhoneAppVerifyDetailsVariant
}

const PhoneAppVerifyDetails: FC<Props> = ({ variant }) => {
  const { loanOfficer } = useStoreState((state) => state.loanOfficer)
  const { mergedAnswers } = useStoreState((state) => state.answers)

  const summaryDetails = buildSummaryInfo(mergedAnswers, null, variant)

  return (
    // This component is reusing styles from the review page
    <div className="review-page__container --no-grid">
      <div className={`review-page__details-container `}>
        {summaryDetails.map((section, sectionIndex) => (
          <div
            className="review-page__details-section-container"
            key={section.title + sectionIndex}
          >
            <div className="review-page__details-section-title">
              {section.title}
            </div>
            <div className="review-page__details-section-content">
              {section.properties.map((property, propertyIndex) =>
                property.value ? (
                  <React.Fragment key={property.value + propertyIndex}>
                    <div className="review-page__details-section-content-heading">
                      {property.heading}
                    </div>
                    <div className="review-page__details-section-content-body">
                      {property.value}
                    </div>
                  </React.Fragment>
                ) : null
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="review-page__rate-lo-info-container --phone-app">
        <LoanOfficerPopUp
          loanOfficer={loanOfficer}
          heading="Does your info look wrong?"
          body="We can fix it, "
        />
      </div>
    </div>
  )
}

export default PhoneAppVerifyDetails
